module.exports = __webpack_public_path__ + "img/clients-disabled.c1d8892f.svg";